import { SORT_BY } from '../constants/action-types';

export const sortBy = (sortBy = '') => ({
    type: SORT_BY,
    sortBy
});